<template>
  <div>
    <jor_18bar />

    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูลสถานศึกษารายงาน สาขาวิชาสำหรับตำแหน่งว่าง"
        class="px-5 py-3"
      >
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <div class="text-center font-weight-bold">
              <v-chip color="success" class="mr-1">
                <h3>
                  <v-icon>mdi-check-circle</v-icon> {{ collegeReport.countcf || 0 }}
                </h3>
              </v-chip>
              <v-chip color="error" class="font-weight-bold mr-1">
                <h3><v-icon>mdi-alert</v-icon> {{ collegeReport.countcc || 0 }}</h3>
              </v-chip>

              <v-chip color="warning" class="font-weight-bold">
                <h3>
                  <v-icon>mdi-progress-tag</v-icon> {{ collegeReport.countpc || 0 }}
                </h3>
              </v-chip>
            </div>
          </v-col>
        </v-row>
        
        <!-- ส่วนเลือกรอบโดยการกรอกตัวเลข -->
        <v-row class="mt-4 mb-2" align="center">
            <v-col cols="12" md="2">
              <v-text-field
                v-model="inputTimes"
                label="ครั้งที่"
                outlined
                dense
                hide-details
                type="number"
                prepend-inner-icon="mdi-counter"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="inputYear"
                label="ปี (พ.ศ.)"
                outlined
                dense
                hide-details
                type="number"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn color="primary" rounded @click="fetchReportData">
                <v-icon left>mdi-magnify</v-icon> ค้นหารายงาน
              </v-btn>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn color="success" rounded @click="exportExcel">
                <v-icon left>mdi-file-excel</v-icon> ส่งออกข้อมูล (XLSX)
              </v-btn>
            </v-col>
        </v-row>
        
        <v-data-table
          color="success"
          :headers="showHeaders"
          :items="college_manpower_reports"
          :search="search"
          class="mt-1"
        >
          <template v-slot:top>
            <div>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
                class="mb-2"
              />
            </div>
            <div>
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                label="เลือกคอลัมน์ที่ต้องการแสดง"
                multiple
                outlined
                return-object
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 6">
                    <span>{{ item.text }}</span>
                  </v-chip>
                  <span v-if="index === 6" class="grey--text caption"
                    >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
                  >
                </template>
              </v-select>
            </div>
          </template>

          <template v-slot:item.college_manpower_reportfile="{ item }">
            <div>
              <v-btn
                v-if="item.college_manpower_reportfile != '-'"
                icon
                @click="viewpdf(item.college_manpower_reportfile)"
              >
                <v-icon size="40" color="info">mdi-file-pdf-box</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.college_manpower_reportfilestatus="{ item }">
            <div>
              <v-btn
                v-if="item.college_manpower_reportfilestatus === 'cc'"
                outlined
                rounded
                color="red"
                @click="cancelAlert(item.college_manpower_reportref)"
              >
                <v-icon size="30" color="red">mdi-alert</v-icon>
                <v-icon size="30" color="red">mdi-closed-caption</v-icon>
              </v-btn>

              <v-icon
                v-else-if="item.college_manpower_reportfilestatus === 'cf'"
                color="success"
                >mdi-check-circle</v-icon
              >

              <v-icon size="30" v-else color="warning">mdi-progress-tag</v-icon>
            </div>
          </template>

          <template v-slot:item.college_manpower_reporttimestamp="{ item }">
            <div>
              {{
                item.college_manpower_reporttimestamp
                  | moment("add", "543 year")
                  | moment("D MMMM YYYY")
              }}
            </div>
          </template>

          <template v-slot:item.del_action="{ item }">
            <div>
              <v-btn
                @click="delReport(item.college_manpower_reportref)"
                color="error"
                fab
                small
                dark
                ><v-icon size="30">mdi-delete-circle</v-icon></v-btn
              >
            </div>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <!-- V-model viewDialog -->
      <v-layout row justify-center>
        <v-dialog v-model="viewDialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="'/HRvecCollegeIdPos/' + viewfile"
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import jor_18bar from "../../components/admin/jor_18bar";
import { logSensitiveAccess } from "@/utils/sensitiveAccessLog";

export default {
  components: { jor_18bar },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      search: "",
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ID_Ref", align: "left", value: "college_manpower_reportref" },
        {
          text: "สถานศึกษา",
          align: "left",
          value: "college_manpower_reportcollege"
        },
        { text: "สถานศึกษา", align: "left", value: "user_firstname" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ภาค", align: "center", value: "region_name" },
        {
          text: "จำนวน",
          align: "center",
          value: "college_manpower_reportcountpos"
        },
        { text: "ไฟล์", align: "center", value: "college_manpower_reportfile" },
        {
          text: "สถานะ",
          align: "center",
          value: "college_manpower_reportfilestatus"
        },
        {
          text: "วันที่",
          align: "center",
          value: "college_manpower_reporttimestamp"
        },
        {
          text: "ยกเลิกทั้งหมด",
          align: "center",
          value: "del_action"
        }
      ],
      
      // ตัวแปรสำหรับระบุรอบและปี
      inputTimes: "",
      inputYear: "",
      
      period_colleges: {},
      college_manpower_reports: [],
      collegeReport: {
        countcc: 0,
        countcf: 0,
        countpc: 0
      },
      college_manpower_reportCC: [],
      college_manpower_CC: {},
      viewfile: [],
      viewDialog: false,
      
      // ตัวแปรสำหรับ editDialog ที่ไม่ได้ใช้งานแต่จำเป็นต้องมีไว้กัน error
      editedIndex: -1,
      editedItem: {
        id_no: 0,
        j18_reason: ""
      },
      defaultItem: {
        id_no: 0,
        j18_reason: ""
      },
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.periodQuery(); // โหลดค่าเริ่มต้น (รอบปัจจุบันที่เปิดอยู่)
  },

  methods: {
    async periodQuery() {
      try {
        let result_period_college = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: "701"
        });
        
        this.period_colleges = result_period_college.data;
        if (this.period_colleges) {
           // ตั้งค่า default ให้เป็นรอบปัจจุบัน
           this.inputTimes = this.period_colleges.period_college_times;
           this.inputYear = this.period_colleges.period_college_year;
           
           // ดึงข้อมูลรายงานอัตโนมัติตามรอบล่าสุด
           await this.fetchReportData();
        }
      } catch (error) {
        console.error("Error fetching current period:", error);
      }
    },
    
    async fetchReportData() {
        if (!this.inputTimes || !this.inputYear) {
            Swal.fire({
              icon: "warning",
              title: "ข้อมูลไม่ครบถ้วน",
              text: "กรุณาระบุ 'ครั้งที่' และ 'ปี' ให้ครบก่อนค้นหา",
              confirmButtonText: "ตกลง"
            });
            return;
        }
        
        this.loading = true;
        try {
            let result = await this.$http.post("college_manpower_report.php", {
              ApiKey: this.ApiKey,
              college_manpower_reporttime: this.inputTimes,
              college_manpower_reportyear: this.inputYear
            });
            
            this.college_manpower_reports = result.data || [];
            
            let countcc = 0;
            let countcf = 0;
            let countpc = 0;
            
            if (this.college_manpower_reports && this.college_manpower_reports.length > 0) {
              this.college_manpower_reports.forEach(value => {
                if (value.college_manpower_reportfilestatus == "cc") {
                  countcc += 1;
                } else if (value.college_manpower_reportfilestatus == "cf") {
                  countcf += 1;
                } else {
                  countpc += 1;
                }
              });
            }
            
            this.collegeReport = {
                countcc: countcc,
                countcf: countcf,
                countpc: countpc
            };

            logSensitiveAccess(
              this.$http,
              "jor18_report",
              "view",
              `รอบ ${this.inputTimes}/${this.inputYear}`
            );
        } catch (error) {
            console.error("Error fetching report data:", error);
            this.college_manpower_reports = [];
            this.collegeReport = { countcc: 0, countcf: 0, countpc: 0 };
        } finally {
            this.loading = false;
        }
    },

    async exportExcel() {
      try {
        if (!this.college_manpower_reports || this.college_manpower_reports.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "ไม่มีข้อมูล",
            text: "ไม่พบข้อมูลสำหรับการส่งออก",
            showConfirmButton: false,
            timer: 1500
          });
          return;
        }

        const dataToExport = this.college_manpower_reports.map((item, index) => {
          let statusText = "รอดำเนินการ";
          if (item.college_manpower_reportfilestatus === "cc") statusText = "ขอยกเลิก";
          else if (item.college_manpower_reportfilestatus === "cf") statusText = "อนุมัติ/เสร็จสิ้น";

          return {
            "ลำดับ": index + 1,
            "รหัสอ้างอิง (ID_Ref)": item.college_manpower_reportref || "-",
            "รหัสสถานศึกษา": item.college_manpower_reportcollege || "-",
            "ชื่อสถานศึกษา": item.user_firstname || "-",
            "จังหวัด": item.province_name || "-",
            "ภาค": item.region_name || "-",
            "จำนวนตำแหน่งว่าง": item.college_manpower_reportcountpos || 0,
            "สถานะการรายงาน": statusText,
            "วันที่ทำรายการ": item.college_manpower_reporttimestamp || "-"
          };
        });

        const XLSX = await import("xlsx");
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        
        let sheetName = `รายงาน_${this.inputTimes}_${this.inputYear}`;
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const filename = `ข้อมูลรายงานสาขาวิชาว่าง_${this.inputTimes}_${this.inputYear}.xlsx`;
        XLSX.writeFile(workbook, filename);
        logSensitiveAccess(this.$http, "jor18_report", "export", filename);

        Swal.fire({
          icon: "success",
          title: "ส่งออกไฟล์ Excel สำเร็จ",
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error) {
        console.error("Export Excel Error: ", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาดในการส่งออก",
          text: "โปรดตรวจสอบการติดตั้ง package 'xlsx'",
          showConfirmButton: true
        });
      }
    },

    async viewpdf(college_manpower_reportfile) {
      this.viewfile = college_manpower_reportfile;
      this.viewDialog = true;
    },
    
    async delReport(college_manpower_reportref) {
      let result = await this.$http.post("college_manpower_report.php", {
        ApiKey: this.ApiKey,
        college_manpower_reportref: college_manpower_reportref
      });
      this.college_manpower_reportCC = result.data;

      Swal.fire({
        title: "ลบรายการ",
        text: "ลบเพื่อดำเนินการสร้างใหม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.college_manpower_reportCC.ApiKey = this.ApiKey;

          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRvecfiles/" +
              this.college_manpower_reportCC.college_manpower_reportfile
          });

          let resultup = await this.$http.post(
            "college_manpower_report.delete.php",
            this.college_manpower_reportCC
          );

          this.college_manpower_CC.ApiKey = this.ApiKey;
          this.college_manpower_CC.college_manpower_ref = college_manpower_reportref;

          await this.$http.post(
            "college_manpower.deleteidref.php",
            this.college_manpower_CC
          );

          if (resultup.data.status == true) {
            Swal.fire({
              title: "ดำเนินการข้อมูลเรียบร้อย",
              icon: "success",
              showConfirmButton: false,
              timer: 1500
            });
            await this.fetchReportData();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },
    
    async cancelAlert(college_manpower_reportref) {
      let result = await this.$http.post("college_manpower_report.php", {
        ApiKey: this.ApiKey,
        college_manpower_reportref: college_manpower_reportref
      });
      this.college_manpower_reportCC = result.data;

      Swal.fire({
        title: "ขอยกเลิกการแนบไฟล์",
        text: "เนื่องจากแนบไฟล์ผิดพลาด",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.college_manpower_reportCC.ApiKey = this.ApiKey;

          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRvecfiles/" +
              this.college_manpower_reportCC.college_manpower_reportfile
          });

          this.college_manpower_reportCC.college_manpower_reportfile = "-";
          this.college_manpower_reportCC.college_manpower_reportfilestatus = "-";

          let resultup = await this.$http.post(
            "college_manpower_report.update.php",
            this.college_manpower_reportCC
          );

          if (resultup.data.status == true) {
            Swal.fire({
              title: "ดำเนินการข้อมูลเรียบร้อย",
              icon: "success",
              showConfirmButton: false,
              timer: 1500
            });
            await this.fetchReportData();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async editItem(item) {
      this.editedIndex = this.college_manpower_reports.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },

    async save() {
      this.editedItem.ApiKey = this.ApiKey;
      Object.assign(
        this.college_manpower_reports[this.editedIndex],
        this.editedItem
      );
      let resultmat = await this.$http.post(
        "college_manpower_report.updateIdno.php",
        this.editedItem
      );
      if (resultmat.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "ทำรายการซ้ำ",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.close();
    },

    async college_manpower_reportQueryAll() {
        // อัปเดตเพื่อรองรับโค้ดเก่าที่อาจมีการเรียกใช้งานเมธอดนี้
        await this.fetchReportData();
    }
  },
  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  }
};
</script>